import { commonStore } from '../global-store/subjects/common';
import { skyFoundationSettings } from '../services/configs/configs-service';

export const isInjectedHP = () => commonStore.getValue().isInjectedHP;

export const isInjectedHPInView = () => commonStore.getValue().isInjectedHPInView;

export const isHomepageInArticle = () => skyFoundationSettings.getLazyLoadedHomepage();
